import React from "react";
import { Row, Col, Card } from "antd";
import { css } from "glamor";
import location_of_entities from "../img/entity_locations.png";
import time_spent from "../img/time_spent_per_case.png";
import current_pipeline_status from "../img/current_pipeline_status.png";
import time_spent_in_different_cases from "../img/time_spent_in_different_cases.png";
import cases_completed_per_week from "../img/cases_completed_per_week.png";
import risk_types_per_week from "../img/risk_types_per_week.png";
import adverse_terms_analysis from "../img/adverse_terms_analysis.png";
import { getAuthorization } from "@arachnys/flow-app/src/api";
import IframeResizer from "iframe-resizer-react";

const imageStyle = css({
    maxWidth: "100%",
});

const headerStyle = css({
    paddingBottom: "40px",
});

class InsightPage extends React.Component {
    constructor(props) {
        super(props);
        this.operationalDashboardImgs = [
            {
                title: "Location of Entities",
                src: location_of_entities,
            },
            {
                title: "Time Spent per Case (Weekly Average in Minutes)",
                src: time_spent,
            },
            {
                title: "Current Pipeline Status",
                src: current_pipeline_status,
            },
            {
                title: "Time Spent in Different Case Stages (Hours per week)",
                src: time_spent_in_different_cases,
            },
            {
                title: "Cases Completed per Week",
                src: cases_completed_per_week,
            },
        ];

        this.riskDashboardImgs = [
            {
                title: "Risk Types Identified (per Week)",
                src: risk_types_per_week,
            },
            {
                title: "Adverse Media - Keyword Efficiency Analysis",
                src: adverse_terms_analysis,
            },
        ];
    }

    state = { iframe_url: undefined };
    renderImg = location => {
        return <img src={location} />;
    };

    renderColumn = entry => {
        return (
            <Col key={entry.src} span={12}>
                <Card
                    {...imageStyle}
                    title={entry.title}
                    bordered
                    className={`${imageStyle}`}
                    cover={this.renderImg(entry.src)}
                />
            </Col>
        );
    };

    renderSection = (title, imgs) => {
        return (
            <div className={`${headerStyle}`}>
                <h1>{title}</h1>
                <Row gutter={16}>{imgs.map(this.renderColumn)}</Row>
            </div>
        );
    };

    componentDidMount() {
        this.getDashboard();
    }

    insightIframe = iframe_url => (
        <IframeResizer
            heightCalculationMethod="bodyScroll"
            src={iframe_url}
            style={{
                width: "100%",
                border: 0,
            }}
        />
    );

    getDashboard = async () => {
        const auth = await getAuthorization();

        const request = new Request("/dashboard/insight/", {
            method: "GET",
            headers: {
                Authorization: auth,
            },
        });
        const response = await fetch(request);

        if (response.ok) {
            const jsonRes = await response.json();
            this.setState({
                iframe_url: jsonRes.iframe_url,
            });
        }
    };

    render() {
        const iframe_url = this.state.iframe_url;
        if (iframe_url) {
            return <div>{this.insightIframe(iframe_url)}</div>;
        }

        return (
            <div>
                {this.renderSection(
                    "Operational dashboards",
                    this.operationalDashboardImgs
                )}
                {this.renderSection("Risk dashboards", this.riskDashboardImgs)}
            </div>
        );
    }
}

export default InsightPage;
